export default __webpack_public_path__ + "static/media/ios_app_store_black.8c4986ee.svg";